var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.979,
    height: 161.5,
    viewBox: "0 0 154.979 161.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart_7306952",
    d: "M107.094,125.424a2.5,2.5,0,0,1-2.492,2.492H97.095v-9.433c3.4.439,6.731.969,10,1.614Zm-45.934-23.59V97.881l8.289-5.911H87v15.374c-6.828-.523-13.9-.775-21.274-.879a4.648,4.648,0,0,1-4.568-4.631ZM136.926,61.4a127.428,127.428,0,0,1-25.872,8.356V79.867a12.117,12.117,0,0,1-12.1,12.1H97.094v16.371c13.991,1.731,27.055,4.921,39.831,10.635Zm28.384-6.79a14.191,14.191,0,0,0-27.551-4.784,115.352,115.352,0,0,1-26.7,9.593V12.107A12.119,12.119,0,0,0,98.949,0H22.437A12.119,12.119,0,0,0,10.332,12.106V79.867a12.117,12.117,0,0,0,12.105,12.1h9.092v17.242a5.047,5.047,0,0,0,7.978,4.108l11.875-8.467A14.8,14.8,0,0,0,65.589,116.56q1.178.017,2.341.038v30.809A14.109,14.109,0,0,0,82.023,161.5H92.048a5.047,5.047,0,0,0,5.047-5.047V138.01H104.6a12.6,12.6,0,0,0,12.588-12.586v-2.912a112.888,112.888,0,0,1,20.57,8.043,14.191,14.191,0,0,0,27.551-4.787V54.614ZM68.294,46.449,79.345,35.4H76.328a5.047,5.047,0,0,1,0-10.094h15.2a5.047,5.047,0,0,1,5.047,5.047v15.2a5.047,5.047,0,1,1-10.094,0V42.537L71.862,57.156a5.047,5.047,0,0,1-7.138,0L53.092,45.523,33.424,65.19a5.048,5.048,0,0,1-7.138-7.139L49.523,34.818a5.041,5.041,0,0,1,7.138,0Z",
    transform: "translate(-10.332)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.93e0a4d3354b241b35cae692e07ca37e.svg";
export { ForwardRef as ReactComponent };